/**
 * WordPress dependencies
 */
import { registerStore } from '@wordpress/data';
/**
 * Internal dependencies
 */

import reducer from './reducer';
import * as selectors from './selectors';
import * as actions from './actions';
registerStore('core/rich-text', {
  reducer: reducer,
  selectors: selectors,
  actions: actions
});
//# sourceMappingURL=index.js.map